import { useAuth0 } from '@auth0/auth0-react';
import { useState, useEffect } from 'react';

export default function useAccessToken() {
	const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

	const [token, setToken] = useState<string | null>(null);

	useEffect(() => {
		getAccessTokenSilently()
			.then(t => setToken(t))
			.catch(() => loginWithRedirect({ appState: { returnTo: window.location.pathname } }));
	}, [getAccessTokenSilently, loginWithRedirect]);

	return token;
}
